module.exports = __webpack_public_path__ + "aa41df641101b875aa01eac7cb62105e.jpg";